import classNames from "classnames";

const Badge = ({
  children,
  success,
  danger,
  progress,
  artwork,
  unfulfilled,
  error,
  gray,
  darknavy,
  newBadge,
  ...rest
}: any) => {
  return (
    <span
      className={classNames(
        `inline-flex items-center gap-1 px-[10px] py-[2px] m-0.5 text-xs rounded-[6px] font-medium whitespace-nowrap ${rest.className}`,
        {
          "bg-taggedblue text-primarynavy":
            !success &&
            !progress &&
            !danger &&
            !error &&
            !artwork &&
            !unfulfilled &&
            !gray &&
            !darknavy &&
            !newBadge,
          "bg-green-100 text-green-800": success,
          "bg-purple-100 text-purple-800": progress,
          "bg-red-100 text-red-600": danger,
          "bg-[#F9DEDE] text-[#E25C5C]": error,
          "bg-yellow-300 text-green-800": artwork,
          "bg-yellow-300 text-[#332E00]": unfulfilled,
          "bg-[#e3e3e3]": gray,
          "bg-primarynavy text-white": darknavy,
          "bg-primaryred text-white rounded-full": newBadge,
        }
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
